import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { Survey } from '../../builders/survey_builder';
import { SurveyQuery } from '../../queries/survey_query';

export class SurveyIntroductionController {
  private matchBackButton?: string;

  constructor(
    private ngSurveyQuery: SurveyQuery,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private appConfigModel: any
  ) {
    this.matchBackButton = undefined;
    if (PlatformUtility.isMobile()) {
      this.matchBackButton = this.appConfigModel.navIconTheme() || 'primary';
    }
  }

  get survey() {
    return _4.find(this.ngSurveyQuery.result, (survey: Survey) => survey.id === this.$stateParams.surveyID);
  }

  get surveyTitle() {
    return this.survey.external_title;
  }

  isMobile(): boolean {
    return PlatformUtility.isMobile();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/views/survey_introduction/survey_introduction_controller.ts